
































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { alertStore, modalAlertStore } from '@/store'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { Alert, AlertLevel } from '@/api'
import { audioNotify } from '@/utils'
import { AlertCodeBAT00015 } from '@/types'
import { ModalAlertAddButton } from '@/store/ModalAlertStore'

@Component({
  components: {
    DataTable,
    ModalFooter
  }
})
export default class ModalAlert extends ComponentVue {
  @Ref()
  modalFooter!: ModalFooter

  get alertLevel(): any {
    return AlertLevel
  }

  get cols(): Col[] {
    return [
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '20',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'code',
            headerText: 'コード'
          }
        ]
      },
      {
        width: '80',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'message',
            headerText: 'メッセージ',
            lineFeed: true
          }
        ]
      }
    ]
  }

  get isOpen(): boolean {
    return modalAlertStore.isOpen
  }

  get modalType(): string {
    if (modalAlertStore.modalType) return modalAlertStore.modalType
    if (this.items.length) return this.items[0].level
    return ''
  }

  get isUseOk(): boolean {
    return modalAlertStore.isUseOk
  }

  get addButtons(): ModalAlertAddButton[] {
    return modalAlertStore.addButtons
  }

  // 重複メッセージを除外している
  get items(): Alert[] {
    return alertStore.items.filter(
      (value: Alert, index: number, items: Alert[]) => {
        return (
          items.findIndex(
            item => item.code === value.code && item.message === value.message
          ) === index
        )
      }
    )
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      setTimeout(() => {
        audioNotify()
        this.modalFooter.focusOkButton()
      })
    }
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-alert')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  // ここは継承で管理する。継承元では使用する予定がないので常にfalseとする
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  displayRemoveButton(index: number): boolean {
    return false
  }

  onClickOk(): void {
    modalAlertStore.ok()

    const sessionTimeOutItem = this.items.find(
      item => item.code === AlertCodeBAT00015
    )
    if (sessionTimeOutItem) {
      location.href = '/login'
    }
  }

  onClickCancel(): void {
    modalAlertStore.cancel()
  }

  onClickRemove(index: number): void {
    modalAlertStore.remove(index)
  }
}
